export default "__VITE_ASSET__IZEiw4iy__"